import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaInstagram,
  FaYoutube,
  FaXTwitter,
  FaRedditAlien,
  FaDiscord
} from 'react-icons/fa6';

const SocialMediaSection = () => {
  const socialPlatforms = [
    {
      name: 'Instagram',
      handle: '@octagoninfinity',
      url: 'https://instagram.com/octagoninfinity',
      icon: FaInstagram,
      gradient: 'from-pink-500 to-purple-600',
      description: 'Daily insights & exclusive content'
    },
    {
      name: 'YouTube',
      handle: '@octagoninfinity',
      url: 'https://youtube.com/@octagoninfinity',
      icon: FaYoutube,
      gradient: 'from-red-500 to-red-600',
      description: 'Investment tutorials & market analysis'
    },
    {
      name: 'X (Twitter)',
      handle: '@octagoninfinity',
      url: 'https://x.com/octagoninfinity',
      icon: FaXTwitter,
      gradient: 'from-gray-700 to-black',
      description: 'Real-time market updates & news'
    },
    {
      name: 'Reddit',
      handle: 'r/octagoninfinity',
      url: 'https://reddit.com/r/octagoninfinity',
      icon: FaRedditAlien,
      gradient: 'from-amber-500 to-red-600',
      description: 'Community discussions & insights'
    },
    {
      name: 'Discord',
      handle: 'octagoninfinity',
      url: 'https://discord.gg/octagoninfinity',
      icon: FaDiscord,
      gradient: 'from-indigo-500 to-purple-600',
      description: 'VIP member exclusive chat'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-gray-900 via-amber-900/20 to-gray-900 relative overflow-hidden" id="social">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-600/5 to-blue-600/5"></div>
        {/* Animated background particles */}
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-amber-400 rounded-full opacity-30"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -20, 0],
              opacity: [0.3, 0.8, 0.3],
              scale: [1, 1.5, 1],
            }}
            transition={{
              duration: 4 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Social Media Grid */}
        <motion.div
          className="max-w-6xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-8 lg:mb-12 px-4">
            <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Follow Our <span className="bg-gradient-to-r from-yellow-400 to-blue-400 bg-clip-text text-transparent">Journey</span>
            </h3>
            <p className="text-lg lg:text-xl text-gray-300 max-w-4xl mx-auto">
              Stay updated with exclusive investment opportunities, market insights, and community discussions. 
              Join thousands of elite investors already part of the Octagon infinity family.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6">
            {socialPlatforms.map((platform, index) => (
              <motion.a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gray-800/50 backdrop-blur-lg rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-gray-700 hover:border-transparent transition-all duration-300 text-center"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 + 0.4 }}
                viewport={{ once: true }}
                whileHover={{ 
                  scale: 1.05, 
                  y: -10,
                  boxShadow: "0 20px 40px rgba(251, 191, 36, 0.2)"
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className={`w-12 h-12 lg:w-16 lg:h-16 bg-gradient-to-r ${platform.gradient} rounded-xl lg:rounded-2xl flex items-center justify-center mx-auto mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <platform.icon className="w-6 h-6 lg:w-8 lg:h-8 text-white" />
                </div>
                
                <h4 className="text-base lg:text-xl font-bold text-white mb-1 lg:mb-2 group-hover:text-amber-300 transition-colors duration-300">
                  {platform.name}
                </h4>
                
                <p className="text-amber-400 font-semibold mb-1 lg:mb-2 group-hover:text-blue-400 transition-colors duration-300 text-sm lg:text-base">
                  {platform.handle}
                </p>
                
                <p className="text-xs lg:text-sm text-gray-400 group-hover:text-gray-300 transition-colors duration-300">
                  {platform.description}
                </p>
              </motion.a>
            ))}
          </div>
        </motion.div>

        {/* Call to Action - Removed as requested */}
      </div>
    </section>
  );
};

export default SocialMediaSection;